
import React from 'react';
import { useDispatch } from 'react-redux';

import { getArticles, getIsArticlesLoaded } from '../reducers/common/articles';
import articlesGetActions from '../sagas/articles';

import useArticlesState from './useArticlesState';

export default function useArticles() {
    const dispatch = useDispatch();
    const articlesActions = articlesGetActions(dispatch);
    const articlesState = useArticlesState();
    const articles = getArticles(articlesState);

    const isArticlesLoaded = getIsArticlesLoaded(articlesState);

    React.useEffect(() => {
        if (!isArticlesLoaded) {
            articlesActions.getArticles();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isArticlesLoaded]);

    return articles;
}
